import { render, staticRenderFns } from "./BaseMenuComponent.vue?vue&type=template&id=a6411a7a&scoped=true"
import script from "./BaseMenuComponent.vue?vue&type=script&lang=ts"
export * from "./BaseMenuComponent.vue?vue&type=script&lang=ts"
import style0 from "./BaseMenuComponent.vue?vue&type=style&index=0&id=a6411a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6411a7a",
  null
  
)

export default component.exports